import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-click',
  templateUrl: './icon-click.component.html',
  styleUrls: ['./icon-click.component.scss'],
})
/**
 * Icon with some action after click
 */
export class IconClickComponent {
  private _small: boolean = false;
  private _flat: boolean = false;
  private _disabled: boolean = false;

  /**
   * Decides if the component size is small
   */
  @Input()
  get small(): boolean {
    return this._small;
  }

  /**
   * Sets this component size as small by using an html attribute
   * @param {any} value
   */
  set small(value: any) {
    this._small = coerceBooleanProperty(value);
  }

  /**
   * Decides if the icon is flat
   */
  @Input()
  get flat() {
    return this._flat;
  }

  /**
   * Sets this as a flat icon
   * @param {any} value
   */
  set flat(value: any) {
    this._flat = coerceBooleanProperty(value);
  }

  /**
   * Whether this form field is disabled or not
   */
  @Input()
  get disabled() {
    return this._disabled;
  }

  /**
   * Sets this as a disabled icon
   * @param {any} value
   */
  set disabled(value: any) {
    this._disabled = coerceBooleanProperty(value);
  }
}
